import React from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import { dotted_line } from "../../../assets/images/fluster";
import { exclamation } from "../../../assets/images/fluster";
import { one } from "../../../assets/images/fluster";
import { two } from "../../../assets/images/fluster";
import { three } from "../../../assets/images/fluster";
import { exclamation1 } from "../../../assets/images/fluster";
import { exclamation2 } from "../../../assets/images/fluster";
import { exclamation3 } from "../../../assets/images/fluster";

const Asker = (props) => {
  const { parameters, asker_player_details, average_points, points } = props;
  const display_name = _.get(asker_player_details, "display_name");
  const profile_image = _.get(asker_player_details, "profile_image");
  const info = _.get(
    parameters,
    "2_asker.info",
    "This is the reader. Who's going to answer?"
  );
  const max_points = _.get(
    parameters,
    "2_asker.max_points",
    "Maximum point level allowed"
  );

  const get_max_points_image = (points) => {
    switch (points) {
      case 1:
        return (
          <>
            {" "}
            <img src={exclamation3} />
          </>
        );
      case 2:
        return (
          <>
            {" "}
            <img src={exclamation2} />
          </>
        );
      case 3:
        return (
          <>
            {" "}
            <img src={exclamation3} />
          </>
        );
    }
  };

  return (
    <div className="asker-main-content">
      <div className="top-content">
        <div className="left-content">
          <FluserUser
            display_name={display_name}
            profile_image={profile_image}
          />
        </div>
        <div className="middle-content">
          <img src={dotted_line} alt="" />
        </div>
        <div className="right-content">
          <p>{max_points}</p>
          {get_max_points_image(points)}
        </div>
      </div>
      <div className="bottom-content">
        <h3>{info}</h3>
      </div>
    </div>
  );
};

export default Asker;
